var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3315",
    "data-name": "Groupe 3315",
    transform: "translate(-1180 -558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2916",
    "data-name": "Rectangle 2916",
    transform: "translate(1180 558)",
    fill: "none",
    stroke: "#f2f2f2",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 49,
    height: 49,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen",
    "data-name": "Icon awesome-pen",
    d: "M9.971,3.2l4.391,4.391L4.828,17.123l-3.915.432A.823.823,0,0,1,0,16.646L.44,12.728,9.971,3.2Zm7.106-.654L15.016.483a1.647,1.647,0,0,0-2.329,0L10.747,2.422l4.391,4.391,1.939-1.939a1.647,1.647,0,0,0,0-2.329Z",
    transform: "translate(1198.221 576.22)",
    fill: "#3e3e3e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.fb90c4bb7aa19f1796479b20b7f555f8.svg";
export { ForwardRef as ReactComponent };